import { Link } from 'react-router-dom';

const Menu = ({ isMenuOpen, setIsMenuOpen }) => {
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const logoStyle = {
    color: 'white',
    marginLeft: '35px',
    textDecoration: 'none',
  }
  

  return (
    <nav className="menu">
      <div className="sidebar__logo" onClick={toggleMenu}>
  <h1 style={logoStyle}>IRENEE</h1>
</div>

      <ul className="menu__list" onClick={toggleMenu}>
      <li className="menu__list-item">
          <Link to="/">Home</Link>
        </li>
        <li className="menu__list-item">
          <Link to="/about">About Me</Link>
        </li>
        <li className="menu__list-item">
          <Link to="/contact">Contact Me</Link>
        </li>
      </ul>

      <ul className="menu__social">
        <li className="menu__social-icon">
          <a href="https://github.com/Bondok6" target="_blank" rel="noreferrer">
            <i className="fab fa-github-square"></i>
          </a>
        </li>
        <li className="menu__social-icon">
          <a
            href="https://www.linkedin.com/in/kyrillos-hany/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Menu;
